import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { Link } from "react-router-dom";

const CARDS = [
  { key: "casos", label: "Casos de éxito", to: "/admin/casos" },
  { key: "services", label: "Servicios", to: "/admin/services" },
  { key: "normas", label: "Normas", to: "/admin/normas" },
  { key: "clients", label: "Clientes", to: "/admin/clients" },
  { key: "testimonials", label: "Testimonios", to: "/admin/testimonials" },
  { key: "faqs", label: "FAQs", to: "/admin/faqs" },
  { key: "resources", label: "Recursos", to: "/admin/resources" },
  { key: "contact_requests", label: "Solicitudes", to: "/admin/contact_requests" },
];

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    (async () => {
      const out = {};
      for (const c of CARDS) {
        try {
          const r = await adminApi.list(c.key);
          out[c.key] = r.length;
        } catch { out[c.key] = "—"; }
      }
      setCounts(out);
    })();
  }, []);

  return (
    <div className="p-8 md:p-10" data-testid="admin-dashboard">
      <div className="eyebrow mb-2">— Resumen</div>
      <h1 className="font-serif text-4xl md:text-5xl">Dashboard</h1>
      <p className="mt-3 text-sm text-[#4A4A4A]">Contenido publicado en el sitio KB Consultoría.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} className="border border-[#1A1A1A]/15 p-6 hover:bg-[#EFEBE2] transition-colors" data-testid={`admin-stat-${c.key}`}>
            <div className="eyebrow text-[#4A4A4A]">{c.label}</div>
            <div className="mt-2 font-serif text-4xl">{counts[c.key] ?? "…"}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
